export default "__VITE_ASSET__Bl7U7R5u__"